import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { Auth0Provider as Auth0ProviderV2 } from "auth0-react-v2";

import { isBrave, isIOS, isSafari } from "@stadium/helpers";

import { SessionProvider } from "@stadium/services/auth/client";

import { onRedirectCallback } from "@stadium/services/auth0/utils";
import { IS_AUTH0_ENABLED } from "@stadium/services/auth0/constants";

/**
 * @deprecated Use AuthServiceProviderV2 from services/auth0".
 */
export const AuthServiceProvider = ({
  children,
  brand,
  clientId,
  audience,
  dbConnection,
  domain,
}) => {
  if (IS_AUTH0_ENABLED) {
    return (
      <Auth0Provider
        audience={audience}
        brand={brand}
        clientId={clientId}
        dbConnection={dbConnection}
        domain={domain}
        scope="read:current_user"
        redirectUri={typeof window === "object" && window.location.origin}
        onRedirectCallback={onRedirectCallback}
        cacheLocation={isSafari() || isIOS() || isBrave() ? "localstorage" : "memory"}
        useRefreshTokens
      >
        {children}
      </Auth0Provider>
    );
  }

  return (
    <SessionProvider refetchOnWindowFocus={false} basePath={process.env.NEXT_PUBLIC_AUTH_BASE_PATH}>
      {children}
    </SessionProvider>
  );
};

export const AuthServiceProviderV2 = ({
  children,
  brand,
  clientId,
  audience,
  dbConnection,
  domain,
  history,
}) => {
  if (IS_AUTH0_ENABLED) {
    return (
      <Auth0ProviderV2
        authorizationParams={{
          audience,
          redirect_uri: typeof window === "object" && window.location.origin,
          scope: "profile email read:current_user",
          brand,
          dbConnection,
        }}
        clientId={clientId}
        domain={domain}
        onRedirectCallback={(appState) => onRedirectCallback(appState, history)}
        cacheLocation={isSafari() || isIOS() || isBrave() ? "localstorage" : "memory"}
        useRefreshTokens
        useRefreshTokensFallback
      >
        {children}
      </Auth0ProviderV2>
    );
  }

  return (
    <SessionProvider refetchOnWindowFocus={false} basePath={process.env.NEXT_PUBLIC_AUTH_BASE_PATH}>
      {children}
    </SessionProvider>
  );
};
